// Dashboards hub entry for X-One Exposure · Overview (/exposure; was
// /dashboards/vulnerabilities until MP900). Self-contained (no imports) so
// the hub can collect every entry with import.meta.glob.
export const dashboardEntry = {
  key: 'vulnerabilities',
  title: 'Exposure overview',
  description: 'See which vulnerabilities attackers are actually using, where they are, and whether every device is being scanned.',
  route: '/exposure',
  icon: 'radar',
  // The page belongs to X-One Exposure and reads from Posture and Surface.
  app: 'exposure',
  apps: ['posture', 'surface'],
  // Scanner results, devices and the asset inventory are owner/admin
  // only in their own apps.
  adminOnly: true,
  // The route sits behind the app's on/off switch (FeatureFlagRoute).
  flag: 'app.exposure',
} as const;
